import { InlineEdit } from "@/shared/components/EntityPage";
import { type DeviceTypeRecord } from "@/shared/domain/deviceTypes";
import { useUpdateDeviceType } from "@/shared/domain/deviceTypes/hooks";

/**
 * The type's name, edited in place like a resource page's name: Enter or
 * clicking away saves, Esc restores it. A name is required, so an emptied
 * one is refused rather than saved.
 */
export function EditableDeviceTypeName({
  deviceType,
}: {
  deviceType: DeviceTypeRecord;
}) {
  const { mutateAsync: updateDeviceType } = useUpdateDeviceType();
  return (
    <InlineEdit
      value={deviceType.name}
      onSave={(name) =>
        updateDeviceType({
          deviceTypeId: deviceType.device_type_id,
          resourceOwnerId: deviceType.org_id,
          updates: { name },
        })
      }
      required
      textStyle="title"
      ariaLabel="device type name"
    />
  );
}
